export var EApprovalAttribute;
(function (EApprovalAttribute) {
    EApprovalAttribute["toApprovalByMe"] = "WAIT_APPROVAL";
    EApprovalAttribute["approvedByMe"] = "FINISH_APPROVAL";
    EApprovalAttribute["createdByMe"] = "CREATE_APPROVAL";
})(EApprovalAttribute || (EApprovalAttribute = {}));
export var EApprovalObjectType;
(function (EApprovalObjectType) {
    EApprovalObjectType["order"] = "ORDER";
    EApprovalObjectType["email"] = "EMAIL";
})(EApprovalObjectType || (EApprovalObjectType = {}));
export var IApprovalRecordStatus;
(function (IApprovalRecordStatus) {
    IApprovalRecordStatus["approved"] = "PASS";
    IApprovalRecordStatus["processing"] = "IN_APPROVAL";
    IApprovalRecordStatus["rejected"] = "REJECT";
    IApprovalRecordStatus["recalled"] = "RECALL";
    IApprovalRecordStatus["revoked"] = "REVOKE";
})(IApprovalRecordStatus || (IApprovalRecordStatus = {}));
export const IApprovalRecordStatusMap = {
    PASS: '审批通过',
    IN_APPROVAL: '审批中',
    REJECT: '被驳回',
    RECALL: '已撤回',
    REVOKE: '已作废',
};
export var EApprovalHistoryNodeStatus;
(function (EApprovalHistoryNodeStatus) {
    EApprovalHistoryNodeStatus["started"] = "START_APPROVAL";
    EApprovalHistoryNodeStatus["waiting"] = "WAIT_APPROVAL";
    EApprovalHistoryNodeStatus["approved"] = "PASS";
    EApprovalHistoryNodeStatus["rejected"] = "REJECT";
    EApprovalHistoryNodeStatus["recalled"] = "RECALL";
    EApprovalHistoryNodeStatus["revoked"] = "REVOKE";
    EApprovalHistoryNodeStatus["reSubmit"] = "RESUBMIT_APPROVAL";
})(EApprovalHistoryNodeStatus || (EApprovalHistoryNodeStatus = {}));
export const EApprovalHistoryNodeStatusMap = {
    START_APPROVAL: '发起审批',
    WAIT_APPROVAL: '待审批',
    PASS: '审批通过',
    REJECT: '被驳回',
    RECALL: '已撤回',
    REVOKE: '已作废',
    RESUBMIT_APPROVAL: '重新提交审批',
};
export var IApprovalFlowNodeStatus;
(function (IApprovalFlowNodeStatus) {
    IApprovalFlowNodeStatus["started"] = "START_APPROVAL";
    IApprovalFlowNodeStatus["approved"] = "PASS";
    IApprovalFlowNodeStatus["rejected"] = "REJECT";
    IApprovalFlowNodeStatus["waiting"] = "WAIT_APPROVAL";
    IApprovalFlowNodeStatus["unTrigger"] = "NOT_APPROVAL";
    IApprovalFlowNodeStatus["recalled"] = "RECALL";
    IApprovalFlowNodeStatus["revoked"] = "REVOKE";
})(IApprovalFlowNodeStatus || (IApprovalFlowNodeStatus = {}));
export const approvalStatusMap = {
    0: {
        label: '待审批',
        color: '#4759B2',
        backgroundColor: '',
        borderColor: '#DEEBFD',
    },
    1: {
        label: '驳回',
        color: '#CB493D',
        backgroundColor: '#FFE5E2',
        borderColor: '#FFE5E2',
    },
    2: {
        label: '已审批',
        color: '#398E80',
        backgroundColor: '#D6F7F1',
        borderColor: '#D6F7F1',
    },
    64: {
        label: '撤回',
        color: '#4E5A70',
        backgroundColor: '#E7EBF1',
        borderColor: '#E7EBF1',
    },
};
export var EApprovalTriggerChangeTypes;
(function (EApprovalTriggerChangeTypes) {
    EApprovalTriggerChangeTypes["none"] = "NONE";
    EApprovalTriggerChangeTypes["before"] = "BEFORE";
    EApprovalTriggerChangeTypes["after"] = "AFTER";
    EApprovalTriggerChangeTypes["when"] = "WHEN";
})(EApprovalTriggerChangeTypes || (EApprovalTriggerChangeTypes = {}));
export var ApprovalConfigType;
(function (ApprovalConfigType) {
    ApprovalConfigType["open"] = "OPEN";
    ApprovalConfigType["close"] = "CLOSE";
})(ApprovalConfigType || (ApprovalConfigType = {}));
export const APPROVAL_CHANGE_TYPES_CONFIG = {
    [EApprovalTriggerChangeTypes.none]: { label: '' },
    [EApprovalTriggerChangeTypes.before]: { label: '变更前' },
    [EApprovalTriggerChangeTypes.after]: { label: '变更后' },
    [EApprovalTriggerChangeTypes.when]: { label: '变更时' },
};
export var EApprovalConditionType;
(function (EApprovalConditionType) {
    EApprovalConditionType["equal"] = "EQUAL";
    EApprovalConditionType["notEqual"] = "NOT_EQUAL";
    EApprovalConditionType["greaterThan"] = "GREATER_THAN";
    EApprovalConditionType["greaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    EApprovalConditionType["lessThan"] = "LESS_THAN";
    EApprovalConditionType["lessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    EApprovalConditionType["contain"] = "CONTAIN";
    EApprovalConditionType["notContain"] = "NOT_CONTAIN";
    EApprovalConditionType["empty"] = "IS_EMPTY";
    EApprovalConditionType["notEmpty"] = "IS_NOT_EMPTY";
    EApprovalConditionType["domainBelongTo"] = "DOMAIN_BELONG_TO";
    EApprovalConditionType["domainNotBelongTo"] = "DOMAIN_NOT_BELONG_TO";
    EApprovalConditionType["domainNoneBelongTo"] = "DOMAIN_NONE_BELONG_TO";
})(EApprovalConditionType || (EApprovalConditionType = {}));
export const APPROVAL_CONDITION_CONFIG = {
    [EApprovalConditionType.equal]: { label: '等于' },
    [EApprovalConditionType.notEqual]: { label: '不等于' },
    [EApprovalConditionType.greaterThan]: { label: '大于' },
    [EApprovalConditionType.greaterThanOrEqual]: { label: '大于等于' },
    [EApprovalConditionType.lessThan]: { label: '小于' },
    [EApprovalConditionType.lessThanOrEqual]: { label: '小于等于' },
    [EApprovalConditionType.contain]: { label: '包含' },
    [EApprovalConditionType.notContain]: { label: '不包含' },
    [EApprovalConditionType.empty]: { label: '为空' },
    [EApprovalConditionType.notEmpty]: { label: '不为空' },
    [EApprovalConditionType.domainBelongTo]: { label: '域属于' },
    [EApprovalConditionType.domainNotBelongTo]: { label: '域不属于' },
    [EApprovalConditionType.domainNoneBelongTo]: { label: '域均不属于' },
};
export var MultiSignType;
(function (MultiSignType) {
    MultiSignType["AND"] = "AND";
    MultiSignType["OR"] = "OR";
})(MultiSignType || (MultiSignType = {}));
export var ApprovalCreateNodeType;
(function (ApprovalCreateNodeType) {
    ApprovalCreateNodeType["start"] = "SPONSOR";
    ApprovalCreateNodeType["approver"] = "APPROVER";
    ApprovalCreateNodeType["route"] = "route";
    ApprovalCreateNodeType["condition"] = "CONDITION";
})(ApprovalCreateNodeType || (ApprovalCreateNodeType = {}));
export var ApproverType;
(function (ApproverType) {
    ApproverType["assign"] = "ASSIGN";
    ApproverType["role"] = "ROLE";
    ApproverType["superior"] = "SUPERIOR";
})(ApproverType || (ApproverType = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["ALL"] = "ALL";
    ConditionType["NONE"] = "NONE";
})(ConditionType || (ConditionType = {}));
export var ApprovalTriggerObjectType;
(function (ApprovalTriggerObjectType) {
    ApprovalTriggerObjectType["ORDER"] = "ORDER";
    ApprovalTriggerObjectType["EMAIL"] = "EMAIL";
})(ApprovalTriggerObjectType || (ApprovalTriggerObjectType = {}));
